<template>
    <div v-show="showContainer">
    </div>
</template>


<script>
import framework from '../../framework';
/**
 *  The x-error-container component.
 *  @module components/x-error-container
 */


/**
 * The x-error-container
 */
export default {
    name: 'x-error-container',
    mixins: [
        framework.mixins.abstractElement,
    ],
    computed: {
        /**
         * Whether or not to show the error container.
         * @returns {boolean} Whether or not to show the error container.
         */
        showContainer() {
            return false;
        },
    },
};

</script>



// WEBPACK FOOTER //
// source/components/x-error-container/x-error-container.vue